import { useEffect } from 'react'

import { Outlet, getRouteApi, notFound } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

import { CompanySideBar } from '../../components/CompanySideBar'
import { ClientPortalInviteDialog } from './components/ClientPortalInviteDialog'
import { CompanyDetailsPage } from './components/CompanyDetailsPage'
import { useClientPortalInvite, useGetCompanyDetailsWebPage } from './hooks'

import { SpinnerBox } from './styles'

const routeApi = getRouteApi('/_app/relationships/$id')

const CompanyDetails = () => {
  const { id } = routeApi.useParams()
  const { dialogVisible, openDialog, closeDialog, sendInvite, isLoading: isSendingInvite } = useClientPortalInvite()
  const { data, isFetched, isFetching } = useGetCompanyDetailsWebPage(+id)

  useEffect(() => {
    if (isFetched && !data) {
      throw notFound()
    }
  })

  if (!data || isFetching) {
    return (
      <SpinnerBox>
        <CircularProgress centered />
      </SpinnerBox>
    )
  }

  return (
    <>
      <ClientPortalInviteDialog
        onClose={closeDialog}
        visible={dialogVisible}
        isPending={isSendingInvite}
        companyName={data?.companyName || ''}
        companyId={data?.id || 0}
        onSubmit={sendInvite}
      />
      <CompanySideBar />
      <CompanyDetailsPage data={data} onOpenClientPortalInviteDialog={openDialog} />
      <Outlet />
    </>
  )
}

export default CompanyDetails
